import { render, staticRenderFns } from "./MaintainSchoolInfoList.vue?vue&type=template&id=1286c752&scoped=true&"
import script from "./MaintainSchoolInfoList.vue?vue&type=script&lang=ts&"
export * from "./MaintainSchoolInfoList.vue?vue&type=script&lang=ts&"
import style0 from "./MaintainSchoolInfoList.vue?vue&type=style&index=0&id=1286c752&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1286c752",
  null
  
)

export default component.exports